import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { withTranslation, Trans, withNamespaces } from 'react-i18next';
import axios from 'axios';

import CustomToaster from './CustomToaster';

const styles = theme => ({});

class AddProductButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            jwt: this.props.jwt,            
            api_url: this.props.api_url,
            quantity: 1,
            elementId: this.props.elementId
        };

        this.onPlusButtonClicked = this.onPlusButtonClicked.bind(this);
        this.onEnterPressed = this.onEnterPressed.bind(this);
        this.onQuantityChanged = this.onQuantityChanged.bind(this);
        this.sentEventData = this.sentEventData.bind(this);
    }

    componentWillUnmount() {
        console.log("test write permission");
    }
      
    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.setState({
                data: this.props.data
            });
        }
    }

    onPlusButtonClicked = (e) => {
        let quantity = this.state.quantity; 
        console.log("Send Qty:"+quantity+" Prod:"+this.state.data.webcode.raw);
        this.sentEventData("AddProductEvent",
            {
                product_id: this.state.data.webcode.raw,
                quantity: quantity
            });
        this.setState({quantity:1});
    }
    
    onEnterPressed = (e) => {
        if (e.key === 'Enter') {
            let quantity = this.state.quantity;
            console.log("Send Qty:"+quantity+" Prod:"+this.state.data.webcode.raw);
            this.sentEventData("AddProductEvent",
                {
                    product_id: this.state.data.webcode.raw,
                    quantity: quantity
                });
            this.setState({quantity:1});
        }
    }

    sentEventData = (eventType, eventPayload) => {
        var event = new CustomEvent(eventType, {
          detail: eventPayload,
        });
        document.getElementById(this.state.elementId).dispatchEvent(event);
        window.dispatchEvent(event);
    };
    
    onQuantityChanged = (e) => {
        let quantity = e.target.value;
        this.setState({'quantity':quantity});
    }

    render() {

        const {quantity} = this.state;

        return (                         
            <div className="AddProductWrapper"> 
                {this.props?.showPlusQtyButton?(
                <input 
                    type="number" 
                    value={quantity}
                    className="qtyInput" 
                    onChange={(e) => this.onQuantityChanged(e)}
                    onKeyDown={(e) => this.onEnterPressed(e)}
                />):("")}
                <li 
                    className="plusQtySendButton" 
                    onClick={(e) => this.onPlusButtonClicked(e)}
                >
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 18 18"  xmlSpace="preserve" height="18" width="18">
                    <path  d="M17.7,8.7H9.3V0.3C9.3,0.1,9.2,0,9,0C8.8,0,8.7,0.1,8.7,0.3v8.4H0.3C0.1,8.7,0,8.8,0,9c0,0.2,0.1,0.3,0.3,0.3h8.4v8.4
                        C8.7,17.9,8.8,18,9,18c0.2,0,0.3-0.1,0.3-0.3V9.3h8.4C17.8,9.3,18,9.2,18,9C18,8.8,17.8,8.7,17.7,8.7"/>
                    </svg>

                </li>                          
            </div>            
        );

    }

}

export default withStyles(styles)(withTranslation()(AddProductButton));